import React, { useEffect, useState } from "react";
import { Text, View, TouchableOpacity } from "react-native";

import styles from "./timeStyles";

export default function TimeSlotItemEndTime(props) {
  const { timeslot, onPress } = props;

  const [endTime, setEndTime] = useState(null);
  const [meridian, setMeridian] = useState(null);

  useEffect(() => {
    if (!timeslot.endTime) return;

    const times = timeslot.endTime.split(" ");
    if (times[0]) setEndTime(times[0]);
    if (times[1]) setMeridian(times[1]);
  }, [timeslot.endTime]);

  return (
    <View style={styles.container}>
      {onPress ? (
        <TouchableOpacity
          onPress={onPress}
          style={[styles.timeContainer]}
        >
          {endTime ? (
            <Text style={[styles.time, onPress ? styles.enabledTime : {}]}>
              {endTime}
            </Text>
          ) : null}
          {meridian ? (
            <Text style={[styles.meridian, onPress ? styles.enabledTime : {}]}>
              {meridian}
            </Text>
          ) : null}
        </TouchableOpacity>
      ) : (
        <View style={styles.timeContainer}>
          {endTime ? <Text style={[styles.time]}>{endTime}</Text> : null}
          {meridian ? <Text style={[styles.meridian]}>{meridian}</Text> : null}
        </View>
      )}
      <View style={styles.border}></View>
    </View>
  );
}
